import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/landing.css";
import useTranslation from "../hooks/useTranslation";

function Landing() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStart = () => {
    navigate('/language');
  };

  return (
    <div className="landing-container">
        {/* Video en el centro */}


      {/* Botón START con tamaño y posición fijos */}
      <div 
        className="landing-button" 
        onClick={handleStart} 
        role="button" 
        tabIndex={0} 
        onKeyDown={(e) => e.key === 'Enter' && handleStart()}
      >
        {t('landing.startButton')}
      </div>
    </div>
  );
}

export default Landing;
